export default [
  '050', // SBI저축
  '064', // 산림조합중앙회
  '089', // 케이뱅크
  '090', // 한국카카오
]
